import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CurrencyPipe, DatePipe } from '@angular/common';
import {
  authInterceptor,
  PermissionsService,
  provideSecurepaySharedConfig,
  providePermissions,
  provideSession,
} from '@shared';
import { environment } from '../environments/environment';
import { provideAuth } from '@auth';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideSecurepaySharedConfig({
      apiBaseUrl: environment.baseAPI,
      production: environment.production,
    }),
    provideAuth({
      baseApi: environment.baseAPI,
    }),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true,
      progressBar: true,
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: providePermissions,
      deps: [PermissionsService],
      multi: true,
    },
    // Registered after providePermissions so permissions load from the token first.
    provideSession(),
    DatePipe,
    CurrencyPipe,
  ],
};
